// フローティング買い物ボタン
$(function () {
  var floatingTop = $(".block_cartbtn_fixed");

  // メニューのtop座標を取得する
  //    if($('.trand').length){
  //		var offsetTop = $(".trand").offset().top;
  //	}
  var deviceWidth = $(window).width();
  if (deviceWidth > "767") {
    var offsetTop = "550"; // 通常800、台風100
  } else {
    var offsetTop = "750"; // 通常800、台風100
  }

  var floatMenuTop = function () {
    // スクロール位置がメニューのtop座標を超えたら固定にする
    if ($(window).scrollTop() > offsetTop) {
      floatingTop.fadeIn().css("display", "flex");
      $("#pageTop").fadeIn();
    } else {
      floatingTop.fadeOut();
      $("#pageTop").fadeOut();
    }
  };
  $(window).scroll(floatMenuTop);
});

// box_accordion
$(function () {
  $(".box_accordion .switch span").on("click", function () {
    $(this).parent().prev("div.text").toggleClass("all");
    var now_class = $(this).attr("class");
    if (now_class == 'open') {
      $(this).attr("class", "close");
    } else {
      $(this).attr("class", "open");
    }
  })
})

// この商品について問い合わせる
$(function () {
  $(".product_item_contact_btn").on("click", function () {
    $("#product_item_contact").fadeIn();
    $("#product_item_contact_back").fadeIn();
  });
  $("#product_item_contact_back").on("click", function () {
    $("#product_item_contact").fadeOut();
    $("#product_item_contact_back").fadeOut();
  });
  $(".product_item_contact_close").on("click", function () {
    $("#product_item_contact").fadeOut();
    $("#product_item_contact_back").fadeOut();
  });
});

// この商品について問い合わせる　送信完了後
$(function () {
  var flagmail = location.search;
  console.log(flagmail);
  if (location.search == "?contact_posted=true") {
    $("#product_item_contact").css("display", "block");
    $("#product_item_contact_back").css("display", "block");
    $("#product_item_contact label").css("display", "none");
    $("#product_item_contact input").css("display", "none");
    $("#product_item_contact textarea").css("display", "none");
    $("#product_item_contact").addClass("form_success");
    $("#product_item_contact .product_info > p").css("display", "none");
    $("#page_item_contact label").css("display", "none");
    $("#page_item_contact input").css("display", "none");
    $("#page_item_contact textarea").css("display", "none");
    $("#page_item_contact textarea").css("display", "none");
  }
});

// 商品詳細ページ　商品画像
var galleryTop3 = new Swiper(".product_main_images", {
  loop: true,
  on: {
    slideChangeTransitionStart: function () {
      // スライド切り替え時は、ループで複製された動画も含めて停止する。
      this.el.querySelectorAll("video").forEach(function (video) {
        video.pause();
      });
    },
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  thumbs: {
    swiper: {
      el: ".product_main_thumbnail",
      slidesPerView: 5, // サムネイル画像の枚数
      spaceBetween: 5,
    },
  },
  navigation: {
    nextEl: ".swiper-button-product-next",
    prevEl: ".swiper-button-product-prev",
  },
  breakpoints: {
    // 768px以上の場合
    768: {
      pagination: false,
    },
  },
});

// 商品詳細ページ テキストアコーディオン
$(function () {
  $(".box_commentary .switch span").on("click", function () {
    $(this).parent().prev(".text").toggleClass("open");
    var now_class = $(this).attr("class");
    if (now_class == 'open') {
      $(this).attr("class", "close");
      $(this).html("閉じる");
    } else {
      $(this).attr("class", "open");
      $(this).html("もっと見る");
    }
  })
})

// 商品詳細ページ　選べるギフト画像
var galleryTop3 = new Swiper(".product_choice_container", {
  slidesPerView: 2.3, // サムネイル画像の枚数
  spaceBetween: 10,
  //loop: true,
  breakpoints: {
    // 768px以上の場合
    768: {
      slidesPerView: 3,
      navigation: {
        nextEl: ".swiper-button-choice-next",
        prevEl: ".swiper-button-choice-prev",
      },
    },
  },
});

$(function () {
  if ($('div').hasClass('type_choice')) {
    var cnt = 0;
    var item_num = $(".product_choice_item").attr("class");
    item_array = item_num.split(" ");
    switch (item_array[2]) {
      case "cho_col2":
        var item_type = 2;
        break;
      case "cho_col3":
        var item_type = 3;
        break;
      case "cho_col4":
        var item_type = 4;
        break;
    }
    $(".alart_choice_num").html("現在<span>" + cnt + "</span>/<span>" + item_type + "</span>商品を選択しています。");
    $("#list_select_choice_items").attr("class", "hidden");
    $(".product_choice_item input").change(function () {
      var vals = "";
      var cnt = 0;
      $(".product_choice_item input").each(function () {
        var prop = $(this).prop("checked");
        if (prop) {
          //var val = $(this).val();
          var val = $(this).data("shortname");
          vals = vals + "<li>" + val + "</li>";
          cnt++;
        }
      })
      $("#list_select_choice_items ol").html(vals);
      if (cnt != 0) {
        $("#list_select_choice_items").attr("class", "visible");
      } else {
        $("#list_select_choice_items").attr("class", "hidden");
      }
      if (cnt == item_type) {
        $("#product_fv_right .product-form__item>span").css("display", "none");
        $(".product_choice_item input:not(:checked)").prop('disabled', true);
      } else {
        $("#product_fv_right .product-form__item>span").css("display", "flex");
        $(".product_choice_item input:not(:checked)").prop('disabled', false);
      }
      $(".alart_choice_num").html("現在<span>" + cnt + "</span>/<span>" + item_type + "</span>商品を選択しています。");
    })
  }
})
